"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.step.progress': 'Paso {current} de {total}',
};
